export enum SpecialTransfersPermissions {
  MboSpecialTransfer = 'mbo-special-transfer',
  VoSpecialTransfer = 'vo-special-transfer',
  SpecialTransfer = 'special-transfer',
}
